<template>
  <div>
    <div v-if="!promotions.length" class="empty-state grey--text mt-0">
      {{ $t('entities.promotions.noPromotions') }}
    </div>
    <template v-else>
      <CatalogPromotionCard
        v-for="promotion in promotions"
        :key="promotion.id"
        :variants="variants"
        :arena-currency="arenaCurrency"
        :promotion="promotion"
        :quantity="getPromotionQuantity(promotion)"
        @update-quantity="$emit('quantity-change', $event)" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CatalogPromotionCard from './PromotionCard.vue'

export default {
  name: 'CatalogPromotions',
  components: {
    CatalogPromotionCard,
  },
  props: {
    variants: { type: Array, default: () => [] },
    arenaCurrency: { type: Object, default: () => ({}) },
    promotions: { type: Array, required: true },
  },
  computed: {
    ...mapGetters('cart', ['cartItems']),
  },
  methods: {
    getPromotionQuantity(promotion) {
      const selectedPromotion = this.cartItems.find(
        (item) =>
          item.type === 'promotion' && item.promotion.id === promotion.id,
      )
      if (!selectedPromotion || selectedPromotion.type !== 'promotion') return 0
      return selectedPromotion.quantity
    },
  },
}
</script>
